/**
 *
 * Filtering related configuration
 *
 */

// types of content we will allow filtering on
// each type must have a corresponding `{type}FilterBar.vue` component
export const filteredTypes = [
  'news',
  'events',
  'resources',
  'service-providers',
  'search',
]

// Types of filters we will accept
// each type must have a corresponding `FilterBy{type}.vue` component
// any items not in this array will be ignored when creating related filter components
export const validFilters = [
  'states',
  'audiences',
  'topics',
  'resource-type',
  'service-type',
]

// Extra params we will be careful to not wipe out when filtering
// (this should not include 'page' as we DO want to reset that when the filters change)
export const extraParams = [
  'term',
  '_storyblok',
  '_storyblok_c',
  '_storyblok_tk',
  '_storyblok_version',
  '_storyblok_lang',
  '_storyblok_release',
]
